import React from 'react'
import type {useDisclosure} from './use-disclosure'

export const DisclosureContext = React.createContext<ReturnType<typeof useDisclosure> | null>(null)
